/**
 * @param {string} classes
 * @return {boolean} add the classes to the element
 */
export function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(' ')
}
